import { render, staticRenderFns } from "./MitAllSpacesList.vue?vue&type=template&id=23c07d94&scoped=true"
import script from "./MitAllSpacesList.vue?vue&type=script&lang=js"
export * from "./MitAllSpacesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c07d94",
  null
  
)

export default component.exports